export const GITFLIC_PIPELINES_PROXY_URL = '/gitflic/api';
export const GITFLIC_ANNOTATION = 'gitflic.ru/project-slug';

export const GITFLIC_READ_SCOPES = [
  'USER_READ',
  'PROJECT_READ',
  'TEAM_READ',
  'COMPANY_READ',
  'REPOSITORY_READ',
];

export const GITFLIC_WRITE_SCOPES = [
  'USER_WRITE',
  'PROJECT_WRITE',
  'PROJECT_EDIT',
  'TEAM_WRITE',
  'COMPANY_WRITE',
  'REPOSITORY_WRITE',
];
